/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubsystemResponseDto } from './SubsystemResponseDto';
import {
    SubsystemResponseDtoFromJSON,
    SubsystemResponseDtoFromJSONTyped,
    SubsystemResponseDtoToJSON,
    SubsystemResponseDtoToJSONTyped,
} from './SubsystemResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListSubsystemsResponseDto
 */
export interface ListSubsystemsResponseDto {
    /**
     * 
     * @type {Array<SubsystemResponseDto>}
     * @memberof ListSubsystemsResponseDto
     */
    data: Array<SubsystemResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListSubsystemsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListSubsystemsResponseDto interface.
 */
export function instanceOfListSubsystemsResponseDto(value: object): value is ListSubsystemsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListSubsystemsResponseDtoFromJSON(json: any): ListSubsystemsResponseDto {
    return ListSubsystemsResponseDtoFromJSONTyped(json, false);
}

export function ListSubsystemsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSubsystemsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SubsystemResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListSubsystemsResponseDtoToJSON(json: any): ListSubsystemsResponseDto {
    return ListSubsystemsResponseDtoToJSONTyped(json, false);
}

export function ListSubsystemsResponseDtoToJSONTyped(value?: ListSubsystemsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SubsystemResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

